module.exports = __webpack_public_path__ + "704d25d61c367ac8530a6945152b42d0.png";